module.exports = __webpack_public_path__ + "img/radio.d9ad142b.svg";